import { Pipe, PipeTransform } from '@angular/core';
import { TreeRemovalReasonAppEntityDictionaryTreeRemovalReason } from '../../openapi';

@Pipe({
  name: 'treeRemovalReason',
  standalone: true
})
export class TreeRemovalReasonPipe implements PipeTransform {

  constructor() {
  }

  transform(value?: string[], reasons?: TreeRemovalReasonAppEntityDictionaryTreeRemovalReason[], otherReason?: string): string {
    let r: any = reasons?.filter(v => value?.includes(v?.id || ''))
      .filter(v => v.code !== 'inna')
      .map(v => v.name);
    if (otherReason) {
      r.push(otherReason)
    }
    return r.join(', ') || '';
  }

}
